import { MemberDetailsComponent } from './member-details/member-details.component';
import { MembersComponent } from './members.component';
import { Routes } from '@angular/router';

export const MEMBERS_ROUTES: Routes = [
    {
        path: '',
        component: MembersComponent,
        data: { section: "ADMIN_MEMBERS_SECTION", routeAdmin: true }
    },
    {
        path: ':value',
        component: MemberDetailsComponent,
        pathMatch: 'full',
        data: { section: "ADMIN_MEMBERS_SECTION", routeAdmin: true, backEnabled: true }
    },
];
